import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function AdminContact() {
  const { authHeaders } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/contact", { headers: authHeaders() }).then((r) => setItems(r.data));
  }, []);

  return (
    <div data-testid="admin-contact">
      <h1 className="text-3xl font-extrabold mb-6">Contact Submissions</h1>
      <div className="space-y-4">
        {items.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-slate-200 p-6">
            <div className="flex justify-between items-start mb-3">
              <div>
                <div className="font-bold text-brand-navy">{c.name}</div>
                <div className="text-sm text-slate-500">{c.email} {c.phone && `• ${c.phone}`}</div>
                {c.city && <div className="text-sm text-slate-500">📍 {c.city}</div>}
              </div>
              <div className="text-xs text-slate-400">{new Date(c.created_at).toLocaleString()}</div>
            </div>
            <p className="text-slate-700">{c.message}</p>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-500">No submissions yet.</div>}
      </div>
    </div>
  );
}
